import React, { Component }  from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from '../Styles/stylesheet_UHS'

import ForumIcon from "@material-ui/icons/Forum";
import Fab from "@material-ui/core/Fab";

import '../Assets/CSS/common.css'
const CrudButton = withStyles(
  styles.crudBtn,
)(Fab);


class ChatButtonText extends Component {
  constructor(props) {
    super(props)
    this.state = {

      width: 0, height: 0,

    }

  }
  componentDidMount() {

  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }





  render() {
    return (


      <div className='chat_footer'>
       
        <div className="row ">

          <div className="col-md-7">
            {
              this.props.show ?
              <>
                <h5 className='h5_tag'> Health Sharing in not insurance, but can be a great way of reducing your medical expenses by sharing your eligible expenses with members of the UHF community.
                </h5>
                {/* <p>*See <a href="https://www.universalhealthfellowship.org/wp-content/uploads/2020/02/UHS-State-Legal-Notices-UHS-SLN-22820.pdf" target="_blank" >link</a> for important legal notices.</p> */}
                </>
                :
                null
            }

          </div>
          <div className="col-md-5 text-right">
          <div className='rightAlign' style={{marginBottom:'8px'}}>
            {
              this.props.fromAgent ?
              <div style={{height:'56px'}}></div>
              :
              <CrudButton className={'purechat-button-expand'} color="primary" aria-label="add" style={styles.CommonChatBtn}>
                <ForumIcon />
              </CrudButton>
            }
              
            </div>
            <p><b>Have Questions about our programs?</b></p>
              {
                this.props.fromAgent ?
                <p>{`Chat with a Health Share Representative or call 
                  ${sessionStorage.getItem('customerServiceNo')}`}</p>
                :
                <p>{`Chat with a Health Share Representative or call 
                  ${sessionStorage.getItem('customerServiceNo')}`}</p>
              }
            

            <p style={{marginTop:20}}><b>Need technical help with  this page?</b></p>
              {
                this.props.fromAgent ?
                <p>Chat with a Support Representative or call (800) 921-4505 Option 3.</p>
                :
                <p>Chat with a Support Representative or call (800) 921-4505 Option 3.</p>
              }
          </div>

        </div>
      </div>






    )
  }




}
export default ChatButtonText;